(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finer-details"] && !Shopify.designMode) return;
  try {
    
function playWorkshopVideo(panel) {
  const video = panel.querySelector('video');
  if (!video || !video.autoplay) return;
  video.muted = true;
  const playing = video.play();
  if (playing && playing.catch) playing.catch(() => {});
}

document.addEventListener('click', event => {
  const summary = event.target.closest('.finer-details__accordion-header');
  const panel = summary && summary.closest('.finer-details__panel[data-type="tab_factory"]');
  if (panel && !summary.parentElement.open) playWorkshopVideo(panel);
});

document.addEventListener('toggle', event => {
  if (!event.target.matches('.finer-details__accordion')) return;
  const panel = event.target.closest('.finer-details__panel[data-type="tab_factory"]');
  const video = panel && panel.querySelector('video');
  if (!video) return;
  if (event.target.open) playWorkshopVideo(panel);
  else video.pause();
}, true);

document.addEventListener('change', event => {
  if (!event.target.matches('.finer-details__tab-radio')) return;
  const tabs = event.target.closest('.finer-details__tabs');
  const panel = tabs.querySelector('.finer-details__panel[data-type="tab_factory"]');
  const video = panel && panel.querySelector('video');
  if (!video) return;
  if (event.target.id.endsWith('-' + panel.dataset.panel)) playWorkshopVideo(panel);
  else video.pause();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  document.querySelectorAll('.ft-logo-anim').forEach((wrapper) => {
    const img = wrapper.querySelector('img');
    if (!img) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        img.classList.toggle('up', entry.isIntersecting);
      });
    }, { threshold: 0.2 });

    observer.observe(wrapper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-story"] && !Shopify.designMode) return;
  try {
    
  class ScrollStory extends HTMLElement {
    constructor() {
      super();

      this.textSteps = Array.from(this.querySelectorAll('.scroll-story__step-text'));
      this.mediaItems = Array.from(this.querySelectorAll('.scroll-story__media-item'));
      this.dots = Array.from(this.querySelectorAll('.scroll-story__dot'));
      this.stepCount = this.textSteps.length;

      if (!this.stepCount) return;

      this.activeIndex = 0;
      this.ticking = false;

      this.viewportWidth = 0;
      this.mobileViewportHeight = 0;
      this.measureViewport();

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onScrollHandler);
      this.onScroll();
    }

    measureViewport() {
      var width = document.documentElement.clientWidth;
      if (width === this.viewportWidth) return;
      this.viewportWidth = width;

      if (width < 990) {
        var probe = document.createElement('div');
        probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:100svh;width:0;';
        this.appendChild(probe);
        this.mobileViewportHeight = probe.getBoundingClientRect().height || window.innerHeight;
        probe.remove();
        this.style.setProperty('--scroll-story-viewport-height', this.mobileViewportHeight + 'px');
        this.classList.toggle('is-compact', this.mobileViewportHeight < 680);
      } else {
        this.mobileViewportHeight = 0;
        this.style.removeProperty('--scroll-story-viewport-height');
        this.classList.remove('is-compact');
      }
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      this.measureViewport();
      var rect = this.getBoundingClientRect();
      var viewportHeight = this.mobileViewportHeight || window.innerHeight;
      var scrollable = rect.height - viewportHeight;
      var scrolled = -rect.top;
      var progress = scrollable > 0 ? Math.min(1, Math.max(0, scrolled / scrollable)) : 0;
      var index = Math.min(this.stepCount - 1, Math.floor(progress * this.stepCount));
      var activeMedia = this.findActiveMedia(index);

      this.setActive(index, activeMedia);
      this.updateScrubSequence(activeMedia, progress);
    }

    // A media item stays active from its own step onward until a later
    // step defines its own media — so one video/image can span several
    // text captions instead of needing one per caption.
    findActiveMedia(index) {
      var active = null;
      this.mediaItems.forEach((el) => {
        var i = Number(el.dataset.stepIndex);
        if (i <= index && (!active || i > Number(active.dataset.stepIndex))) {
          active = el;
        }
      });
      return active || this.mediaItems[0];
    }

    // Frame-sequence scrubbing swaps a plain <img> to the nearest ALREADY-LOADED
    // still frame instead of seeking a <video>. A paused video frame is decoded
    // from compressed, motion-predicted data (P/B-frames) and looks soft on
    // pause; a real JPEG frame doesn't have that problem.
    updateScrubSequence(activeMedia, progress) {
      if (!activeMedia) return;

      if (activeMedia.__seq === undefined) {
        var img = activeMedia.querySelector('.scroll-story__scrub-sequence');
        var urls = img ? JSON.parse(img.dataset.sequenceUrls || '[]') : [];
        if (img && urls.length) {
          activeMedia.__seq = {
            img: img,
            urls: urls,
            count: urls.length,
            loaded: [true],
            lastIndex: 0
          };

          // Anti-blink: while a newly-assigned frame decodes, the <img> paints
          // nothing for a moment. Holding the previous frame as the element's
          // own background (same object-fit/object-position geometry) means the
          // swap never flashes blank — it just seamlessly holds the last frame.
          img.addEventListener('load', function () {
            img.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
            img.style.backgroundSize = 'contain';
            img.style.backgroundRepeat = 'no-repeat';
            img.style.backgroundPosition = getComputedStyle(img).objectPosition;
          });

          this.preloadSequenceFrame(activeMedia.__seq, 1);
        } else {
          activeMedia.__seq = null;
        }
      }

      var seq = activeMedia.__seq;
      if (!seq) return;

      var startIndex = Number(activeMedia.dataset.stepIndex);
      var nextIndex = this.stepCount;
      this.mediaItems.forEach((el) => {
        var i = Number(el.dataset.stepIndex);
        if (i > startIndex && i < nextIndex) nextIndex = i;
      });

      var spanStart = startIndex / this.stepCount;
      var spanEnd = nextIndex / this.stepCount;
      var span = spanEnd - spanStart;
      var localProgress = span > 0 ? Math.min(1, Math.max(0, (progress - spanStart) / span)) : 0;

      var targetIndex = Math.round(localProgress * (seq.count - 1));
      while (targetIndex > 0 && !seq.loaded[targetIndex]) targetIndex--;

      if (targetIndex !== seq.lastIndex) {
        seq.lastIndex = targetIndex;
        seq.img.src = seq.urls[targetIndex];
      }
    }

    preloadSequenceFrame(seq, index) {
      if (index >= seq.count) return;

      // Shopify Files URLs are only valid once the file's actually been
      // uploaded — skip a blank/missing entry instead of requesting it.
      if (!seq.urls[index]) {
        this.preloadSequenceFrame(seq, index + 1);
        return;
      }

      var self = this;
      var image = new Image();
      image.onload = function () {
        seq.loaded[index] = true;
        self.preloadSequenceFrame(seq, index + 1);
      };
      image.onerror = function () {
        self.preloadSequenceFrame(seq, index + 1);
      };
      image.src = seq.urls[index];
    }

    setActive(index, activeMedia) {
      if (index === this.activeIndex && this.initialized) return;
      this.initialized = true;
      this.activeIndex = index;

      this.textSteps.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-hidden', String(i !== index));
      });

      this.mediaItems.forEach((el) => {
        el.classList.toggle('is-active', el === activeMedia);
        el.setAttribute('aria-hidden', String(el !== activeMedia));
      });

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-filled', i <= index);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onScrollHandler);
    }
  }

  customElements.define('scroll-story', ScrollStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-room"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shop-the-room__swiper .swiper-slide').forEach(function (slide) {
    var firstGroup = slide.querySelector('.shop-the-room__hotspot-group');

    if (firstGroup) {
      firstGroup.classList.add('is-active');
      firstGroup.querySelector('.shop-the-room__hotspot').setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('click', function (event) {
    var hotspotButton = event.target.closest('.shop-the-room__hotspot');

    if (hotspotButton) {
      var group = hotspotButton.closest('.shop-the-room__hotspot-group');
      var slide = group.closest('.swiper-slide');
      var wasActive = group.classList.contains('is-active');

      slide.querySelectorAll('.shop-the-room__hotspot-group.is-active').forEach(function (openGroup) {
        openGroup.classList.remove('is-active');
        openGroup.querySelector('.shop-the-room__hotspot').setAttribute('aria-expanded', 'false');
      });

      if (!wasActive) {
        group.classList.add('is-active');
        hotspotButton.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (
      !event.target.closest('.shop-the-room__hotspot-group') &&
      !event.target.closest('.shop-the-room__footer-row')
    ) {
      document.querySelectorAll('.shop-the-room__hotspot-group.is-active').forEach(function (openGroup) {
        openGroup.classList.remove('is-active');
        openGroup.querySelector('.shop-the-room__hotspot').setAttribute('aria-expanded', 'false');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-reviews-draft"] && !Shopify.designMode) return;
  try {
    
function initVibeHausRecentReviews(root) {
  const scope = root.querySelectorAll('[data-vh-recent]');
  scope.forEach(feed => {
    if (feed.dataset.initialized === 'true') return;
    feed.dataset.initialized = 'true';
    const pageSize = window.matchMedia('(max-width: 749px)').matches ? 3 : 6;
    feed.dataset.pageSize = pageSize;
    [...feed.querySelectorAll('[data-review-id]')].forEach((card, index) => card.hidden = index >= pageSize);
    const more = feed.querySelector('[data-vh-load-more]');
    if (!more) return;
    if (feed.querySelectorAll('[data-review-id]').length <= pageSize) more.parentElement.hidden = true;
    more.addEventListener('click', () => {
      const hiddenCards = [...feed.querySelectorAll('[data-review-id][hidden]')];
      const nextCards = hiddenCards.slice(0, Number(feed.dataset.pageSize) || 6);
      nextCards.forEach(card => card.hidden = false);
      if (hiddenCards.length <= nextCards.length) more.parentElement.hidden = true;
      const status = feed.querySelector('[data-vh-review-status]');
      const count = feed.querySelectorAll('[data-review-id]:not([hidden])').length;
      status.textContent = status.dataset.statusTemplate.replace('__COUNT__', count);
      nextCards[0]?.querySelector('a')?.focus({ preventScroll: true });
    });
  });
}
initVibeHausRecentReviews(document);
document.addEventListener('shopify:section:load', event => initVibeHausRecentReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
